import type * as React from 'react';
import { get } from '@Domain/Api';
import userPermissionsFetched, {
	type UserPermissionsFetchedAction,
	type UserPermissionsFetchedPayload,
} from '@Application/Security/Roles/Actions/userPermissionsFetched';
import userPermissionsFetchFailed, {
	type UserPermissionsFetchFailedAction,
} from '@Application/Security/Roles/Actions/userPermissionsFetchFailed';
import type FetchUserPermissions from '@Application/Security/Roles/Queries/FetchUserPermissions';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = UserPermissionsFetchFailedAction | UserPermissionsFetchedAction;

export default (query: FetchUserPermissions) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			// This query only ever runs for an already authenticated user, so a 401 here signals
			// an expired access token, not the absence of a session: it must trigger a refresh.
			const payload = await get<UserPermissionsFetchedPayload>(
				`${parameters.api.host}/api/permissions/users/${query.userId}`,
				{ retryOnUnauthorized: true },
			);

			const action = userPermissionsFetched(payload);
			dispatch(action);
			return action;
		} catch (error) {
			const action = userPermissionsFetchFailed(extractMessages(error));

			dispatch(action);
			return Promise.reject(action);
		}
	};
};
